import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_supports-color@7.2.0__@types+node@25.9.9_react-dom@19.3._e86a5f44176ef8a7c7e437919c0f0628/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_supports-color@7.2.0__@types+node@25.9.9_react-dom@19.3._e86a5f44176ef8a7c7e437919c0f0628/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/components/actions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/components/change-localization/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/components/change-theme/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/header/header.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/loading-context.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/loading.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/app/src/locales/client.ts");
